import { createSlice } from '@reduxjs/toolkit';

import { SLICER_KEYS } from 'types/services';
import { setConditions } from './reducers/setConditions';
import { updateCondition } from './reducers/updateCondition';
import { addConditionToIndex } from './reducers/addConditionToIndex';
import { removeConditionFromIndex } from './reducers/removeConditionFromIndex';
import { dynamicallyUpdateBase } from './reducers/updateBase';
import type { TemplateType, Condition, DefaultValue } from 'types/helios/templateForms';

export interface HeliosConditionsBaseState {
  name: string;
  description: string;
  type: keyof typeof TemplateType;
  conditions: Condition[];
  defaultValue?: DefaultValue;
  targetItemId?: number;
}

export interface HeliosConditionsState {
  PRE?: HeliosConditionsBaseState;
  CURRENT?: HeliosConditionsBaseState;
}

export type ConditionType = 'PRE' | 'CURRENT';

const initialState: HeliosConditionsState = {
  PRE: {
    name: '',
    description: '',
    type: 'Edit',
    conditions: [],
    defaultValue: undefined,
    targetItemId: undefined,
  },
  CURRENT: {
    name: '',
    description: '',
    type: 'Edit',
    conditions: [],
    defaultValue: undefined,
    targetItemId: undefined,
  },
};

export const heliosConditionsState = createSlice({
  name: SLICER_KEYS.HELIOS_CONDITIONS,
  initialState,
  reducers: {
    setConditions,
    updateCondition,
    addConditionToIndex,
    removeConditionFromIndex,
    dynamicallyUpdateBase,
  },
});

export const heliosConditionsStateActions = heliosConditionsState.actions;
